// AttendanceDropdownEditCell.js
// import React from 'react';
// import { MenuItem, Select } from '@mui/material';
// import { useGridApiContext, useGridSelector, gridEditCellValueSelector } from '@mui/x-data-grid';

// export default function AttendanceDropdownEditCell(props) {
//   const { id, field, value, api } = props;

//   const handleChange = (event) => {
//     api.setEditCellValue({ id, field, value: event.target.value }, event);
//   };

//   return (
//     <Select
//       value={value || ''}
//       onChange={handleChange}
//       fullWidth
//     >
//       <MenuItem value="P">P</MenuItem>
//       <MenuItem value="A">A</MenuItem>
    
//     </Select>
//   );
// };
import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Popover,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export default function AttendanceDropdownEditCell(props) {
  const { id, value, field, row, colDef, api } = props;
  const cellRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const [attendance, setAttendance] = useState(value?.split('|')[0] || '');
  const [remark, setRemark] = useState(value?.split('|')[1] || '');

  useEffect(() => {
    setAnchorEl(cellRef.current);
  }, []);

  // const handleConfirm = (e) => {
  //   e.stopPropagation();
  //   const newValue = `${attendance}${remark ? `|${remark}` : ''}`;
    
  //   // Use the correct API methods for DataGrid
  //   if (api && api.setEditCellValue) {
  //     api.setEditCellValue({ id, field, value: newValue });
  //     api.stopCellEditMode({ id, field });
  //   }
  // };
const handleConfirm = (e) => {
  e.stopPropagation();

  //  Block confirm if remark is empty
  if (!remark?.trim()) {
    return; // Do nothing
  }

  const newValue = `${attendance}${remark ? `|${remark}` : ''}`;

  if (api && api.setEditCellValue) {
    api.setEditCellValue({ id, field, value: newValue });
    api.stopCellEditMode({ id, field });
  }
};

  const handleCancel = (e) => {
    e.stopPropagation();
    if (api && api.stopCellEditMode) {
      api.stopCellEditMode({ id, field });
    }
  };

  return (
    <>
      <Box
        ref={cellRef}
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 1,
        }}
      >
        {attendance || 'Edit'}
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCancel}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableEnforceFocus
        sx={{ 
          zIndex: 2000,
          '& .MuiSelect-select': {
            zIndex: 2500,
          },
          '& .MuiPaper-root': {
            zIndex: 2500,
          }
        }}
      >
        <Box p={2} display="flex" flexDirection="column" gap={1} width={250}>
          <Select
            value={attendance}
            onChange={(e) => setAttendance(e.target.value)}
            fullWidth
            size="small"
            MenuProps={{
              disablePortal: true,
              sx: {
                zIndex: 3000,
              }
            }}
          >
            <MenuItem value="P">Present</MenuItem>
            <MenuItem value="A">Absent</MenuItem>
          </Select>

       <TextField
  value={remark}
  onChange={(e) => setRemark(e.target.value)}
  placeholder="Remarks"
  required
  error={!remark?.trim()} // shows red border if empty
  helperText={!remark?.trim() ? "Remarks are required" : ""}
  size="small"
  fullWidth
  onClick={(e) => e.stopPropagation()}
/>

          <Box display="flex" justifyContent="flex-end" gap={1}>
            <IconButton
              onClick={handleConfirm}
              color="success"
              size="small"
              sx={{ zIndex: 2500 }}
            >
              <CheckIcon />
            </IconButton>
            <IconButton
              onClick={handleCancel}
              color="error"
              size="small"
              sx={{ zIndex: 2500 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Popover>
    </>
  );
} 